
    export default 
    {
    "ad_1688": {
        "top_banner": "Il programma DSers Mass Supplier è attivo! Supportato dal team di fornitori di AliExpress, 1688 e DSers. Ottieni dal 10% al 30% di sconto sui prodotti!",
        "learn_more": "Maggiori informazioni"
    }
}